/**
 * @GENERATED from Figma node 3608:50989
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const ChromeDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#4CAF50"
      d="M22 12c0 5.522-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2s10 4.478 10 10"
    />
    <path
      fill="#FFC107"
      d="M12 2v10l4 2-4.421 8H12c5.526 0 10-4.474 10-10S17.526 2 12 2"
    />
    <path
      fill="#0F9D58"
      d="M22 12c0 5.522-4.478 10-10 10S2 17.522 2 12 6.478 2 12 2s10 4.478 10 10"
    />
    <path
      fill="#FFBA00"
      d="M12 2v10l4 2-4.421 8H12c5.526 0 10-4.474 10-10S17.526 2 12 2"
    />
    <path
      fill="#DB4437"
      d="M20.92 7.5H12V14l-1.5-.5-6.92-6.87h-.01A9.97 9.97 0 0 1 12 2c3.9 0 7.275 2.24 8.92 5.5"
    />
    <path fill="#558B2F" d="m11.579 22 4.467-8.03L14 12.5z" />
    <path fill="#F9A825" d="M20.933 7.5H12l-.79 2.29z" />
    <path fill="#DD2C00" d="m3.579 6.632 4.422 7.431L10.5 13.5z" />
    <path
      fill="#fff"
      d="M16.5 12a4.501 4.501 0 0 1-9 0 4.501 4.501 0 0 1 9 0"
    />
    <path fill="#2196F3" d="M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 1 1 7 0" />
  </svg>
);
const ForwardRef = React.forwardRef(ChromeDark);
export { ForwardRef as ChromeDark };
